import PrestadoresHabilitadosListView from './PrestadoresHabilitadosListView';

export default PrestadoresHabilitadosListView;
